import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface EnterpriseStep3Fields {
	hadNavCollection: boolean;
	hasRescheduledPublicDebt: boolean;
	canOwnerOfferGuarantee: boolean;
	hadMoreThanHalfPropertyOwnership: boolean;
}

export class EnterpriseStep3 extends AbstractStep<EnterpriseStep3Fields> {
	protected renderContent(_values: EnterpriseStep3Fields, form: FormApi<EnterpriseStep3Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						name="hadNavCollection"
						label="Volt inkasszó a vállalkozás számláján az elmúlt 36 hónapban?"
						required
					/>
					<FormDecidable
						name="hasRescheduledPublicDebt"
						label="Van a cégednek átütemezett köztartozása? (pl. NAV részletfizetés)"
						required
					/>
					<FormDecidable
						name="canOwnerOfferGuarantee"
						label="Magánszemély készfizető kezes biztosítékként felajánlható?"
						required
					/>
					<FormDecidable
						name="hadMoreThanHalfPropertyOwnership"
						label="Tulajdonosok/kezesek tulajdonában van ingatlan (min. 1/2 tulajdoni hányad)?"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "EnterpriseStep3";
	}
}
